import { render, staticRenderFns } from "./TextToolbar.vue?vue&type=template&id=1fd618eb&"
import script from "./TextToolbar.vue?vue&type=script&lang=js&"
export * from "./TextToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports